import List from 'notifications/components/list';
import { connect } from 'react-redux';

export function mapStateToProps({ user, notifications }) {
  const notificationsList = user.logged_in ? notifications.data.results : [];

  return {
    typeDisplay: 'read',
    showChecks: true,
    notificationsList: notificationsList.filter(({ read }) => (read)),
  };
}

export default connect(mapStateToProps)(List);



// WEBPACK FOOTER //
// ./notifications/containers/read.js